import * as Yup from 'yup';
import YupPassword from 'yup-password';
YupPassword(Yup);

const updateAccountValidation = Yup.object().shape({
  name: Yup.string().required(),
  type: Yup.string().required().oneOf(["cash", "bank"]),
});

export default updateAccountValidation;
